import { format, isAfter, isEqual, parse } from 'date-fns';
import Api from '../api/Api';
import resolve from  '../util/Configuracao';
class ProfissionalApi extends Api {
  async consultarNomesTodosProfissionais () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosProfissionais');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarEspecialidades () {
    try {
      const especialidadesUrl = resolve('urlConsultarEspecialidades');
      const response = await this.fetch(especialidadesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarEspecialidadesPermitidas (seqPrestador) {
    try {
      const especialidadesPermitidasUrl = resolve('urlConsultarEspecialidadesPermitidas') + seqPrestador;
      const response = await this.fetch(especialidadesPermitidasUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarCROs () {
    try {
      const CROsUrl = resolve('urlConsultarCROs');
      const response = await this.fetch(CROsUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProfissionais (filter) {
    let profissionais = [];
    let arrayPrestador = [];
    const brancoAcoes = '';
    try {
      const profissionaisUrl = resolve('urlConsultarProfissionais') +
      filter.seqPrestador + '/' +
      filter.seqProfissional + '/' +
      filter.seqCRO + '/' +
      filter.seqEspecialidade + '/' +
      filter.seqUF + '/' +
      filter.dataVigencia;

      const { data } = await this.fetch(profissionaisUrl);
      data.map(res => {
        const { seqProfissional, numRegistro, codConselho, siglaConselho, nome, profissionalPrestador } = res;
        for (var i = 0; i < profissionalPrestador.length; i++) {
          if (profissionalPrestador[i].nomePrestador != null) {
            if (profissionalPrestador[i].dtaFim === null) {
              arrayPrestador.push(' * ' + profissionalPrestador[i].nomePrestador + ' desde ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY'));
            } else {
              arrayPrestador.push(' * ' + profissionalPrestador[i].nomePrestador + ' de ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(profissionalPrestador[i].dtaFim), 'DD/MM/YYYY'));
            }
            var especialidades = profissionalPrestador[i].desEspecialidades.split(',');
            for (var j = 0; j < especialidades.length; j++) {
              arrayPrestador.push(especialidades[j]);
            }
            if (profissionalPrestador[i].dtaFim === null) {
              if (i + 1 !== profissionalPrestador.length) {
                arrayPrestador.push('-'.repeat((' * ' + profissionalPrestador[i].nomePrestador + ' desde ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY')).length + 60));
              }
            } else {
              if (i + 1 !== profissionalPrestador.length) {
                arrayPrestador.push('-'.repeat((' * ' + profissionalPrestador[i].nomePrestador + ' de ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(profissionalPrestador[i].dtaFim), 'DD/MM/YYYY')).length + 60));
              }
            }
          } else {
            arrayPrestador.push('Profissional sem prestador vinculado');
          }
        }
        profissionais.push(Object.values({ seqProfissional, nome, numRegistro, codConselho, siglaConselho, arrayPrestador, brancoAcoes, profissionalPrestador }));
        arrayPrestador = [];
      });
      return profissionais || [];
    } catch (error) {
      console.error(error);
    }
  }

  async incluirProfissional (profissional) {
    try {
      const urlIncluirProfissional = resolve('urlIncluirProfissional');
      const response = await this.fetch(urlIncluirProfissional, 'put', profissional);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirProfissional (numProfissional) {
    try {
      const urlExcluirProfissional = resolve('urlExcluirProfissional') + '/' + numProfissional;
      const response = await this.fetch(urlExcluirProfissional, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarProfissional (profissional) {
    try {
      const urlAlterarProfissional = resolve('urlAlterarProfissional');
      const response = await this.fetch(urlAlterarProfissional, 'put', profissional);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  validarDataInicio (data, dataFim) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data fim.';
    }
    return '';
  }
  validarDataFim (data, dataInicio) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data de início.';
    }
    return '';
  }

  async validarProfissional (profissional, indInclusao) {
    try {
      const urlValidarProfissional = `${resolve('urlValidarProfissional')}/${indInclusao}`;
      const result = await this.fetch(urlValidarProfissional, 'POST', profissional, null, { 'content-type': 'text/plain' });

      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
export default ProfissionalApi;
